// Fuente de verdad de las membresías de Pelip. De aquí cuelga TODO: gating de
// features, límites (proyectos/usuarios), qué ve el sidebar por plan y (luego)
// los productos de Stripe. Cambiar un plan aquí lo cambia en toda la app.

export type PlanId = 'free' | 'guionista' | 'pase' | 'indie' | 'line-producer' | 'productora' | 'estudio';

export interface Plan {
  id: PlanId;
  label: string;
  price: number;                 // EUR (0 = por confirmar / gratis)
  interval: 'month' | 'one-off' | null;
  projects: number;
  users: number;
  days?: number;                 // vigencia (solo el pase: 60 días)
  featureSet: 'writer' | 'creative' | 'all' | 'none';
}

// Escalera de membresías. writer = solo narrativa+kit+voz (Guionista) · creative =
// todo menos las 4 de producción (Indie) · all = TODO (One Shot, Productora, Estudio).
// El One Shot es 'all' a propósito: pago único = acceso COMPLETO a 1 proyecto durante 60
// días (si fuera 'creative' sería un Indie más caro y sin sentido junto al Indie mensual).
export const PLANS: Record<PlanId, Plan> = {
  free:       { id: 'free',       label: 'Free',       price: 0,   interval: null,      projects: 0,  users: 1,          featureSet: 'none' },
  guionista:  { id: 'guionista',  label: 'Guionista',  price: 24.90, interval: 'month',   projects: 1,  users: 1,          featureSet: 'writer' },
  pase:       { id: 'pase',       label: 'One Shot',   price: 64.90, interval: 'one-off', projects: 1,  users: 1, days: 60, featureSet: 'all' },
  indie:      { id: 'indie',      label: 'Indie',      price: 29.90, interval: 'month',   projects: 1,  users: 1,          featureSet: 'creative' },
  // Line Producer: para directores/as de producción freelance. Acceso COMPLETO (todas las
  // herramientas, incl. las 4 de producción física) a 2 proyectos a la vez, 1 usuario.
  'line-producer': { id: 'line-producer', label: 'Line Producer', price: 49.90, interval: 'month', projects: 2, users: 1, featureSet: 'all' },
  productora: { id: 'productora', label: 'Productora', price: 99,    interval: 'month',   projects: 5,  users: 3,          featureSet: 'all' },
  estudio:    { id: 'estudio',    label: 'Estudio',    price: 299,   interval: 'month',   projects: 12, users: 6,          featureSet: 'all' },
};

// Features del plan Guionista (creador puro): narrativa, su kit de desarrollo y su
// voz. El resto capado. (Confirmar el set exacto.)
export const WRITER_FEATURES = new Set<string>(['narrativa', 'kit-guionista', 'mi-voz']);

// Mapeo de nombres legacy en la DB → PlanId nuevo.
export const LEGACY_PLAN_MAP: Record<string, PlanId> = {
  studio: 'productora',   // los 7 'studio' actuales → Productora (el tier estrella)
  guionista: 'guionista',
  free: 'free',
};
export const resolvePlan = (raw: string | null | undefined): Plan =>
  PLANS[(LEGACY_PLAN_MAP[raw ?? ''] ?? (raw as PlanId)) as PlanId] ?? PLANS.free;

// Add-on de Indie: cada proyecto extra al mes (29,90 base + 20 → 49,90 por 2, etc.).
// El límite real de un org = plan.projects + extra_projects (organizations.extra_projects).
export const EXTRA_PROJECT_PRICE = 20; // €/mes por proyecto adicional
export const projectLimit = (plan: Plan, extraProjects = 0): number => plan.projects + extraProjects;

// Features capadas para Indie (solo Productora+, featureSet 'all'). Indie tiene
// TODO MENOS estas 4 (decisión Juan): las herramientas más de producción física.
// Presupuesto, diseño de producción y financiación SÍ están en Indie.
export const PRODUCTION_FEATURES = new Set<string>([
  'vfx',            // Breakdown VFX
  'mapa',           // Mapa de localizaciones
  'rodaje',         // Plan de rodaje
  'localizaciones', // Localizaciones
]);

export function planAllows(featureSet: Plan['featureSet'], feature: string): boolean {
  if (featureSet === 'all') return true;
  if (featureSet === 'none') return false;
  if (featureSet === 'writer') return WRITER_FEATURES.has(feature);
  return !PRODUCTION_FEATURES.has(feature); // 'creative' (Indie) = todo menos producción
}
